import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import positionsReducer from '@app/reducers/entities/positions';
import { USER_NOT_INVITED } from '@flow/libs/user';

const COLLEAGUES_QUERY_NAME = 'colleagues-selector';

export function useColleagues() {
  const dispatch = useDispatch();

  const colleagueQuery = useSelector((state) =>
    positionsReducer.getQuerySelector(state, {
      name: COLLEAGUES_QUERY_NAME,
    }),
  );
  const colleagues = useSelector(
    (state) =>
      positionsReducer.getPositionsSelector(state, {
        ids: colleagueQuery.result,
      }),
    shallowEqual,
  );

  const fetch = useCallback(
    (searchValue?: string) => {
      dispatch(
        positionsReducer.queryPositions({
          name: COLLEAGUES_QUERY_NAME,
          pagination: {
            offset: 0,
            limit: 50,
          },
          params: {
            invited: USER_NOT_INVITED,
            q: searchValue && searchValue.length > 0 ? searchValue : undefined,
          },
          sort: [
            'active',
          ],
        }),
      );
    },
    [
      dispatch,
    ],
  );

  const loadMore = (additionalResults: number) => {
    dispatch(
      positionsReducer.queryPositionsLoadMore({
        name: COLLEAGUES_QUERY_NAME,
        additionalResults,
      }),
    );
  };

  return {
    fetch,
    loadMore,
    data: colleagues,
    loading: colleagueQuery.status === 'loading',
    error: colleagueQuery.status === 'error',
    pristine: colleagueQuery.status === 'pristine',
    success: colleagueQuery.status === 'success',
    count: colleagueQuery.count,
  };
}
